import React from "react";
import { Font, StyleSheet, Text, View } from "@react-pdf/renderer";
import cambria from "../../../../font/Cambria.ttf";

Font.register({
  family: "Cambria",
  src: cambria,
  fontStyle: "normal",
  fontWeight: "normal",
});

const styles = StyleSheet.create({
  container: {
    textAlign: "center",
    width: "100%",
    marginTop: 50,
  },
  text: {
    color: "#000000",
    fontSize: 12,
    fontFamily: "Cambria",
  },
});

const Title = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>
        SEÑOR ALCANDE DE LA MUNICIPALIDAD PROVINCIAL DE AREQUIPA
      </Text>
    </View>
  );
};

export default Title;
